import { combineReducers } from 'redux';
import { reducerAnimalList } from '@/modules/AnimalList/reducers/reducerAnimalList';
import { reducerAnimalControlProtectora } from '@/modules/Protectora/reducers/reducerAnimalControlProtectora';
import { reducerAnimal } from '@/modules/Animal/reducers/reducerAnimal';
import { reducerAnimalDetailProtectora } from '@/modules/Protectora/reducers/reducerAnimalDetailProtectora';
import { reducerFilterAnimals } from '@/modules/AnimalList/reducers/reducerFilterAnimals';
import { reducerFiltersAnimalsProtectora } from '@/modules/AnimalList/reducers/reducerFiltersAnimalsProtectora';
import { reducerFilterEntity } from '@/modules/EntityList/reducers/reducerFilterEntity';
import { reducerAnimalDetailProtectoraImagenYVideo } from '@/modules/Protectora/reducers/reducerAnimalDetailProtectoraImagenYVideo';
import { reducerRecomendations } from '@/modules/Recomendations/reducers/reducerRecomendations';
import { reducerEntities } from '@/modules/EntityList/reducers/reducerEntities';
import { reducerEntity } from '@/modules/Entity/reducers/reducerEntity';
import { reducerStructureControl } from '@/modules/Structure/reducers/reducerStructureControl';
import { reducerContactByEmail } from '@/modules/Shared/reducers/reducerContactByEmail';
import {reducerAdminProtectora} from '@/modules/AdminProtectora/reducers/reducerAdminProtectora';
import {createStore, applyMiddleware} from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web and AsyncStorage for react-native
import autoMergeLevel1 from 'redux-persist/lib/stateReconciler/autoMergeLevel1';
import thunk from 'redux-thunk';
// import { routerReducer, routerMiddleware } from 'react-router-redux';

const middleware = [ thunk ];
// const middleware_history = routerMiddleware(browserHistory);

// Config persist
const persistConfig = {
    key: 'root',
    stateReconciler: autoMergeLevel1,
    blacklist: ['animals', 'routing'],
    storage
};

// combinamos nuestros reducers
const reducers = combineReducers({
    animals: reducerAnimalList,
    animalsProtectora: reducerAnimalControlProtectora,
    animalDetail: reducerAnimal,
    animalDetailProtectora: reducerAnimalDetailProtectora,
    animalDetailProtectoraImagenYVideo: reducerAnimalDetailProtectoraImagenYVideo,
    filterAnimals: reducerFilterAnimals,
    filterAnimalsProtectora: reducerFiltersAnimalsProtectora,
    structureControl: reducerStructureControl,
    // routing: routerReducer,
    adminProtectora: reducerAdminProtectora,
    recomendations: reducerRecomendations,
    entities:reducerEntities,
    entity:reducerEntity,
    filterEntities:reducerFilterEntity,
    contactByEmail:reducerContactByEmail
});

const persistedReducer = persistReducer(persistConfig, reducers);

// creamos y exportamos el store con el middleware aplicado y la configuración de la persistencia.
export default () => {
    let store = createStore(
        persistedReducer,
        // applyMiddleware(middleware_history, ...middleware)
        applyMiddleware( ...middleware)
    );
    let persistor = persistStore(store);
    return { store, persistor }
}
/*export default createStore(
    persistedReducer,
    applyMiddleware(middleware_history, ...middleware)
);*/



